// Visuell rendering av HeadingBlock i canvas. Speglar serialize.ts-output.
// Font läses från canvas-context när tillgänglig så att live-uppdateringar i
// mall-inställningar reflekteras direkt i canvas.

import { Box } from '@mui/material';
import { useBlockCanvas } from '../canvasContext';
import { DEFAULT_FONT_STACK, HeadingBlock } from '../types';

const styleByLevel: Record<1 | 2 | 3, { fontSize: string; lineHeight: string }> = {
  1: { fontSize: '28px', lineHeight: '34px' },
  2: { fontSize: '22px', lineHeight: '28px' },
  3: { fontSize: '18px', lineHeight: '22px' },
};

type Props = { block: HeadingBlock };

export const HeadingBlockView = ({ block }: Props) => {
  const ctx = useBlockCanvas();
  const fontFamily = ctx?.docSettings.headingFontFamily ?? DEFAULT_FONT_STACK;
  const Tag = `h${block.level}` as 'h1' | 'h2' | 'h3';
  const styles = styleByLevel[block.level];
  return (
    <Box sx={{ p: '16px 30px', fontFamily, textAlign: block.align }}>
      <Tag
        style={{
          margin: 0,
          color: '#222222',
          fontFamily,
          fontSize: styles.fontSize,
          lineHeight: styles.lineHeight,
        }}
      >
        {block.text}
      </Tag>
    </Box>
  );
};

export default HeadingBlockView;
